import React, {FC, useId} from 'react'
import {
  COMMERCIUM_CART_VIEWBOX_PAD_X,
  COMMERCIUM_CART_VIEWBOX_PAD_Y,
  COMMERCIUM_CART_VIEWBOX_TOTAL_HEIGHT,
  COMMERCIUM_CART_VIEWBOX_TOTAL_WIDTH,
} from './commerciumCartMarkMetrics'

type CommerciumCartMarkFallbackProps = {
  size: number
  displayHeight: number
}

/** Static SVG shown until the canvas paints (avoids empty loader flash). */
const CommerciumCartMarkFallback: FC<CommerciumCartMarkFallbackProps> = ({
  size,
  displayHeight,
}) => {
  const gradientId = `cmm-cart-fallback-${useId().replace(/:/g, '')}`
  return (
  <svg
    className='cmm-cart-loader__fallback-svg'
    viewBox={`0 0 ${COMMERCIUM_CART_VIEWBOX_TOTAL_WIDTH} ${COMMERCIUM_CART_VIEWBOX_TOTAL_HEIGHT}`}
    width={size}
    height={displayHeight}
    preserveAspectRatio='xMidYMid meet'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    shapeRendering='geometricPrecision'
  >
    <defs>
      <linearGradient id={gradientId} x1='0' y1='0' x2='1' y2='0.35'>
        <stop offset='0' stopColor='#0D97D5' />
        <stop offset='0.5' stopColor='#0E7CBB' />
        <stop offset='1' stopColor='#113D7E' />
      </linearGradient>
    </defs>
    <g transform={`translate(${COMMERCIUM_CART_VIEWBOX_PAD_X} ${COMMERCIUM_CART_VIEWBOX_PAD_Y})`}>
      <path
        d='M16 20 Q100 114 184 20'
        stroke={`url(#${gradientId})`}
        strokeWidth='21'
        strokeLinecap='round'
      />
      <circle cx='80' cy='110' r='12' fill={`url(#${gradientId})`} />
      <circle cx='120' cy='110' r='12' fill={`url(#${gradientId})`} />
    </g>
  </svg>
  )
}

export default CommerciumCartMarkFallback
